import React from "react";
import "./tag.css";

const Tag = ({text}) => {
  const tagColor=(text==="RSCIA"?"#003467":"#970303");
  return (
    
      <div className='tag' style={{"background-color":tagColor}}>{text}</div>

  );
};

export default Tag;



// WEBPACK FOOTER //
// ./src/components/atomic/atoms/Tag/Tag.js